import React from 'react';
import PropTypes from 'prop-types';
/* components */
import Keyboard from '../keyboard/keyboard';
/* styles */
import './auth-wrapper.scss';
/* assets */
import logoSrc from '../../assets/images/orbitmi_logo.svg';
import KeyboardContextProvider from '../../context/keyboard-context';

export default class AuthWrapper extends React.Component {
    render() {
        return (
            <KeyboardContextProvider>
                <Keyboard />
                <div className="sten-auth-page">
                    <div className="sten-auth-page__header">
                        <img src={logoSrc} className="sten-auth-page__header-logo" alt="OrbitMI" />
                    </div>
                    <div className="sten-content sten-auth-page__panel">
                        {this.props.heading && (
                            <div className="sten-content__header flex-row">
                                {this.props.goBackUrl && (
                                    <div className="flex-shrink">
                                        {/* eslint-disable-next-line */}
                                        <a href={this.props.goBackUrl} className="btn-link icon icon-arrow-left" />
                                    </div>
                                )}
                                <div className="flex-grow">
                                    <h1 className="sten-content__title">
                                        {this.props.heading}
                                    </h1>
                                    {this.props.subtitle && (
                                        <p className="sten-content__subtitle">{this.props.subtitle}</p>
                                    )}
                                </div>
                            </div>
                        )}
                        {this.props.children}
                    </div>
                    <footer className="sten-auth-page__footer">
                        {`Copyright ® ${new Date().getFullYear()} Orbit Insights`}
                    </footer>
                </div>
            </KeyboardContextProvider>
        );
    }
}

AuthWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    goBackUrl: PropTypes.string,
    heading: PropTypes.string,
    subtitle: PropTypes.string
};

AuthWrapper.defaultProps = {
    goBackUrl: null,
    heading: '',
    subtitle: ''
};
